import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Crown } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle, WhatsAppIcon } from "./shared";
import { api, imgUrl, waLink } from "../../lib/api";

export default function PartnersTeaser() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api.get("/partners").then((r) => setPartners(r.data.items || [])).catch(() => {});
  }, []);

  if (!partners.length) return null;
  const featured = [...partners].sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0)).slice(0, 4);

  return (
    <section className="py-20 lg:py-28 bg-warmwhite" data-testid="partners-teaser">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <Eyebrow>Quem faz o dia acontecer</Eyebrow>
              <SectionTitle>Parceiros para o seu casamento</SectionTitle>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <Link
              to="/parceiros"
              data-testid="partners-view-all"
              className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-olive hover:text-golddark transition-colors border-b-2 border-gold/40 hover:border-gold pb-1"
            >
              CONHEÇA TODOS OS PARCEIROS <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <div className="bg-cream border border-gold/20 rounded-2xl p-6 h-full hover:border-gold/50 hover:shadow-xl hover:shadow-gold/10 hover:-translate-y-1 transition-all duration-500" data-testid={`partner-teaser-${p.id}`}>
                <div className="flex items-center gap-3">
                  {p.logo ? (
                    <img src={imgUrl(p.logo)} alt={`Logo ${p.name}`} className="w-12 h-12 rounded-full object-cover border border-beige" loading="lazy" />
                  ) : (
                    <div className="w-12 h-12 rounded-full bg-olive text-cream flex items-center justify-center font-serif text-lg">{p.name.charAt(0)}</div>
                  )}
                  <div>
                    <p className="font-serif text-lg text-ink leading-tight">{p.name}</p>
                    <p className="text-[11px] uppercase tracking-[0.2em] text-golddark font-semibold mt-0.5">{p.category}</p>
                    {p.featured && (
                      <p className="mt-1 inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.12em] text-golddark">
                        <Crown className="w-3 h-3" /> Destaque
                      </p>
                    )}
                  </div>
                </div>
                {p.address && (
                  <p className="mt-3 text-xs text-cocoa flex items-start gap-1.5">
                    <MapPin className="w-3.5 h-3.5 text-gold shrink-0 mt-0.5" /> {p.address}
                  </p>
                )}
                <a
                  data-testid={`partner-teaser-whatsapp-${p.id}`}
                  href={waLink(p.whatsapp, `Olá! Encontrei ${p.name} no site de Frei Lucas Macieira e gostaria de conversar sobre meu casamento.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => window.gtag && window.gtag("event", "click_parceiro", { partner: p.name })}
                  className="mt-4 inline-flex items-center gap-2 text-xs font-semibold text-whatsappdark hover:text-white border border-whatsapp/40 hover:bg-whatsapp px-4 py-2.5 rounded-full transition-all"
                >
                  <WhatsAppIcon className="w-3.5 h-3.5" /> FALAR COM O PARCEIRO
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
